import axiosServices from 'utils/axios';

export const getNotificationSummary = () =>
  axiosServices.get('/notifications/summary').then((r) => r.data);

export const markNotificationsRead = (payload) =>
  axiosServices.post('/notifications/mark-read', payload).then((r) => r.data);
